@if (qaEnabled) {
  <div class="accept-container m-10 flex flex-column items-center justify-center">
    <span class="title weight-bold m-b-10">Q&amp;A</span>
    <div class="raised-hands-panel">
      <div class="panel-header flex justify-between items-center" (click)="togglePanel()">
        <div class="flex items-center">
          <span class="expansion-title uppercase weight-medium font-s">Raised Hands</span>
          @if (raisedHands.length > 0) {
            <div class="qa-badge m-l-10">{{ raisedHands.length }}</div>
          }
        </div>
        <svg
          width="24"
          [class.collapsed]="panelCollapsed"
          height="24"
          style="float: right"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path fill-rule="evenodd" clip-rule="evenodd" d="M10 17L15 12L10 7V17Z" fill="#333333" />
        </svg>
      </div>
      <div class="panel-body flex flex-column" [class.collapsed]="panelCollapsed">
        <div class="requests-container flex flex-column p-10">
          @for (raisedHand of raisedHands; track raisedHand) {
            <div class="request-box flex flex-column m-b-12">
              <span class="request-time">{{ raisedHand.timestamp | timeDiff }}</span>
              <div class="flex justify-between items-center">
                <span class="name weight-bold font-s word-break">{{ formatUsersName(raisedHand.name) }}</span>
                <div class="buttons-container flex">
                  <button
                    mat-fab
                    class="m-r-6"
                    [disabled]="acceptDisabled"
                    (click)="acceptRaisedHand(raisedHand.userId)"
                  >
                    <mat-icon>done</mat-icon>
                  </button>
                  <button mat-fab (click)="declineRaisedHand(raisedHand.userId)">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          }
        </div>
        <button
          type="button"
          data-testid="disable-qa-button"
          mat-flat-button
          (click)="disableQAMode()"
          class="disable-qa-btn weight-bold font-s"
        >
          Disable Q&amp;A
        </button>
      </div>
    </div>
  </div>
}
